import { OFREPWebProvider } from '@openfeature/ofrep-web-provider'

import { getAccessToken } from '@/shared/lib/auth/token-storage'
import { getHostEnv, sanitizeHost } from '@/shared/lib/utils/host'

const host = window?.location?.hostname || ''
const environment = getHostEnv(sanitizeHost(host))
const capitalizeFirstLetter = (val: string) =>
	String(val).charAt(0).toUpperCase() + String(val).slice(1)
export const fliptProvider = new OFREPWebProvider({
	baseUrl: window.location.origin,
	disableVisibilityRefresh: true,
	changeDetection: 'none',
	headersFactory: () =>
		Promise.resolve([
			['authorization', 'Bearer ' + getAccessToken()],
			['X-Flipt-Environment', capitalizeFirstLetter(environment)],
		]),
})
